module.exports = __webpack_public_path__ + "static/media/ebay-logo.4a68d9bb.png";